module.exports = "<!-- TO BE REMOVED -->\n<div class=\"modal-header\">\n    <h3 class=\"modal-title\"> </h3>\n</div>\n";